import DemoWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "fontFamily",
      description: "fontFamily",
      type: "String",
      default: "icon_com"
    },
    {
      prop: "iconClass",
      description: "iconfont图标类名",
      type: "String"
    },
    {
      prop: "imgSrc",
      description: "图片地址",
      type: "String"
    },
    {
      prop: "size",
      description: "整体尺寸",
      type: "Number",
      default: "20"
    },
    {
      prop: "iconSize",
      description: "icon的fontSize，或者是图片的尺寸",
      type: "Number",
      default: "14"
    },
    {
      prop: "disabled",
      description: "disabled",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
